import pdfMake from 'pdfmake/build/pdfmake';

// CDN шрифты
pdfMake.fonts = {
  Roboto: {
    normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
    bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
    italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
    bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
  }
};

// Вспомогательные функции для работы с текстом и категориями
const getShortLabel = (text, maxLength = 20) => {
  if (!text) return '';
  const parts = text.split(' - ');
  const label = parts[1] || parts[0];
  return label.length > maxLength ? label.substring(0, maxLength) + '...' : label;
};

const getCategoryLabel = (category) => {
  const labels = {
    breakfast: 'Горячие блюда завтрака',
    soups: 'Первые блюда (супы)',
    mainDishes: 'Вторые блюда',
    sides: 'Гарниры',
    fruits: 'Фрукты',
    bakery: 'Выпечка',
    dairy: 'Молочные продукты',
    bread: 'Хлеб',
    drinks: 'Напитки'
  };
  return labels[category] || category;
};

const getLevelLabel = (level) => {
  const levels = {
    city: 'Городской',
    district: 'Районный', 
    school: 'Школьный'
  };
  return levels[level] || level;
};

const getQualityColor = (index) => {
  if (index >= 80) return '#2a9d8f';
  if (index >= 60) return '#e9c46a';
  return '#e76f51';
};

const getQualityText = (index) => {
  if (index >= 80) return 'Отличное качество';
  if (index >= 60) return 'Хорошее качество';
  if (index >= 40) return 'Удовлетворительное';
  return 'Требует улучшений';
};

const getQualityInterpretation = (index) => {
  if (index >= 80) return 'Высокие показатели удовлетворенности и оценок, минимальное количество жалоб';
  if (index >= 60) return 'Стабильные показатели, есть потенциал для улучшений';
  if (index >= 40) return 'Требуются точечные улучшения в проблемных зонах';
  return 'Значительные проблемы с качеством питания и удовлетворенностью';
};

// Улучшенные функции для создания визуализаций
const createSatisfactionComparison = (kidsSatisfaction, parentsSatisfaction) => {
  const kidsRounded = Math.round(kidsSatisfaction);
  const parentsRounded = Math.round(parentsSatisfaction);
  
  return {
    stack: [
      {
        text: 'СРАВНЕНИЕ УДОВЛЕТВОРЕННОСТИ',
        fontSize: 12,
        bold: true,
        color: '#2c3e50',
        margin: [0, 0, 0, 12]
      },
      {
        columns: [
          {
            width: '40%',
            stack: [
              { 
                text: 'ДЕТИ', 
                fontSize: 10, 
                color: '#7f8c8d',
                margin: [0, 0, 0, 4]
              },
              { 
                text: `${kidsRounded}%`, 
                fontSize: 20, 
                bold: true, 
                color: '#3498db' 
              }
            ]
          },
          {
            width: '60%',
            stack: [
              {
                canvas: [
                  {
                    type: 'rect',
                    x: 0, y: 0,
                    w: Math.round((kidsSatisfaction / 100) * 80), h: 12,
                    color: '#3498db',
                    fillOpacity: 0.8
                  }
                ]
              }
            ]
          }
        ],
        margin: [0, 0, 0, 8]
      },
      {
        columns: [
          {
            width: '40%',
            stack: [
              { 
                text: 'РОДИТЕЛИ', 
                fontSize: 10, 
                color: '#7f8c8d',
                margin: [0, 0, 0, 4]
              },
              { 
                text: `${parentsRounded}%`, 
                fontSize: 20, 
                bold: true, 
                color: '#9b59b6' 
              }
            ]
          },
          {
            width: '60%',
            stack: [
              {
                canvas: [
                  {
                    type: 'rect',
                    x: 0, y: 0,
                    w: Math.round((parentsSatisfaction / 100) * 80), h: 12,
                    color: '#9b59b6',
                    fillOpacity: 0.8
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  };
};

const createQualityIndicator = (qualityIndex) => {
  const color = getQualityColor(qualityIndex);
  const roundedIndex = Math.round(qualityIndex);
  
  return {
    stack: [
      {
        text: 'ИНДЕКС КАЧЕСТВА ПИТАНИЯ',
        fontSize: 12,
        bold: true,
        color: '#2c3e50',
        margin: [0, 0, 0, 8]
      },
      {
        text: `${roundedIndex}`,
        fontSize: 28,
        bold: true,
        color: color,
        margin: [0, 0, 0, 2]
      },
      {
        text: 'баллов',
        fontSize: 11,
        color: '#7f8c8d',
        margin: [0, 0, 0, 8]
      },
      {
        canvas: [
          {
            type: 'rect',
            x: 0, y: 0,
            w: Math.round((qualityIndex / 100) * 100), h: 10,
            color: color,
            fillOpacity: 0.8
          }
        ],
        margin: [0, 0, 0, 6]
      },
      {
        text: getQualityText(qualityIndex),
        fontSize: 11,
        color: color,
        bold: true
      }
    ],
    alignment: 'center'
  };
};

const createRatingDistribution = (surveyData) => {
  const ratings = [1, 2, 3, 4, 5];
  const distribution = ratings.map(rating => {
    const ratingData = surveyData.children.find(d => 
      d.question_code === 'Q10' && d.answer === `${rating} балл${rating > 1 ? 'а' : ''}`
    );
    return ratingData ? Math.round(parseFloat(ratingData.percentage.toString().replace(',', '.'))) : 0;
  });

  return {
    stack: [
      {
        text: 'РАСПРЕДЕЛЕНИЕ ОЦЕНОК',
        fontSize: 12,
        bold: true,
        color: '#2c3e50',
        margin: [0, 0, 0, 10]
      },
      {
        table: {
          widths: ['20%', '50%', '30%'],
          body: distribution.map((value, index) => {
            const rating = index + 1;
            let color = '#e74c3c';
            if (value >= 20) color = '#27ae60';
            else if (value >= 10) color = '#f39c12';
            
            return [
              { 
                text: `${rating}`, 
                fontSize: 12, 
                bold: true,
                alignment: 'center'
              },
              {
                canvas: [
                  {
                    type: 'rect',
                    x: 0, y: 0,
                    w: Math.round((value / 100) * 50), h: 10,
                    color: color,
                    fillOpacity: 0.8
                  }
                ]
              },
              { 
                text: `${value}%`, 
                fontSize: 12, 
                bold: true, 
                color: color,
                alignment: 'right'
              }
            ];
          })
        },
        layout: 'noBorders'
      }
    ]
  };
};

const createPopularDishesVisualization = (dishesByCategory) => {
  const popularDishes = [];
  Object.values(dishesByCategory.popular).forEach(dishes => {
    if (dishes && dishes.length > 0) {
      popularDishes.push(...dishes.slice(0, 2));
    }
  });
  
  const topDishes = popularDishes
    .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
    .slice(0, 3);

  if (topDishes.length === 0) {
    return {
      text: 'Нет данных о популярных блюдах',
      fontSize: 11,
      color: '#7f8c8d',
      italics: true,
      alignment: 'center'
    };
  }

  return {
    stack: [
      {
        text: 'ТОП ПОПУЛЯРНЫХ БЛЮД',
        fontSize: 12,
        bold: true,
        color: '#2c3e50',
        margin: [0, 0, 0, 10]
      },
      ...topDishes.map((dish, index) => {
        const percentage = Math.round(parseFloat(dish.percentage.toString().replace(',', '.')));
        const dishName = getShortLabel(dish.question_text, 28);
        
        return {
          columns: [
            {
              width: '10%',
              text: `${index + 1}.`,
              fontSize: 11,
              bold: true,
              color: '#2c3e50'
            },
            {
              width: '50%',
              text: dishName,
              fontSize: 10
            },
            {
              width: '25%',
              canvas: [
                {
                  type: 'rect',
                  x: 0, y: 0,
                  w: Math.round((percentage / 100) * 30), h: 8,
                  color: '#27ae60',
                  fillOpacity: 0.8
                }
              ]
            },
            {
              width: '15%',
              text: `${percentage}%`,
              fontSize: 11,
              bold: true,
              color: '#27ae60'
            }
          ],
          margin: [0, 0, 0, 5]
        };
      })
    ]
  };
};

const createBuffetActivityVisualization = (buyersPercent, sometimesBuffetPercent, notBuyersPercent) => {
  const buyers = Math.round(buyersPercent);
  const sometimes = Math.round(sometimesBuffetPercent);
  const notBuyers = Math.round(notBuyersPercent);

  return {
    stack: [
      {
        text: 'АКТИВНОСТЬ ПОКУПОК В БУФЕТЕ',
        fontSize: 12,
        bold: true,
        color: '#2c3e50',
        margin: [0, 0, 0, 10]
      },
      {
        columns: [
          {
            width: '30%',
            stack: [
              { text: 'РЕГУЛЯРНО', fontSize: 10, color: '#7f8c8d', margin: [0, 0, 0, 4] },
              { text: `${buyers}%`, fontSize: 16, bold: true, color: '#27ae60' },
              {
                canvas: [
                  {
                    type: 'rect',
                    x: 0, y: 0,
                    w: Math.round((buyers / 100) * 40), h: 8,
                    color: '#27ae60',
                    fillOpacity: 0.8
                  }
                ],
                margin: [0, 4, 0, 0]
              }
            ],
            alignment: 'center'
          },
          {
            width: '30%',
            stack: [
              { text: 'ИНОГДА', fontSize: 10, color: '#7f8c8d', margin: [0, 0, 0, 4] },
              { text: `${sometimes}%`, fontSize: 16, bold: true, color: '#f39c12' },
              {
                canvas: [
                  {
                    type: 'rect',
                    x: 0, y: 0,
                    w: Math.round((sometimes / 100) * 40), h: 8,
                    color: '#f39c12',
                    fillOpacity: 0.8
                  }
                ],
                margin: [0, 4, 0, 0]
              }
            ],
            alignment: 'center'
          },
          {
            width: '30%',
            stack: [
              { text: 'НЕ ПОКУПАЮТ', fontSize: 10, color: '#7f8c8d', margin: [0, 0, 0, 4] },
              { text: `${notBuyers}%`, fontSize: 16, bold: true, color: '#e74c3c' },
              {
                canvas: [
                  {
                    type: 'rect',
                    x: 0, y: 0,
                    w: Math.round((notBuyers / 100) * 40), h: 8,
                    color: '#e74c3c',
                    fillOpacity: 0.8
                  }
                ],
                margin: [0, 4, 0, 0]
              }
            ],
            alignment: 'center'
          }
        ]
      }
    ]
  };
};

const createMetricCard = (title, value, unit = '', description = '') => {
  return {
    stack: [
      {
        text: title,
        fontSize: 10,
        color: '#7f8c8d',
        margin: [0, 0, 0, 4]
      },
      {
        text: value + unit,
        fontSize: 18,
        bold: true,
        color: '#2c3e50',
        margin: [0, 0, 0, 2]
      },
      ...(description ? [{
        text: description,
        fontSize: 9,
        color: '#95a5a6',
        italics: true
      }] : [])
    ],
    alignment: 'center'
  };
};

// Базовые функции расчета (остаются без изменений)
const calculateSatisfaction = (data, questionCode, positiveAnswer) => {
  if (!data) return 0;
  const item = data.find(d => d.question_code === questionCode && d.answer === positiveAnswer);
  if (!item) return 0;
  
  const percentage = parseFloat(item.percentage.toString().replace(',', '.'));
  return Math.round(percentage);
};

const calculateAverageRating = (data) => {
  if (!data) return '0.0';
  
  const breakfastRatings = data.filter(d => 
    d.question_code === 'Q10' && d.answer?.includes('балл')
  );
  
  let totalScore = 0;
  let totalWeight = 0;
  
  breakfastRatings.forEach(rating => {
    const score = parseInt(rating.answer);
    const weight = parseFloat(rating.percentage.toString().replace(',', '.'));
    totalScore += score * weight;
    totalWeight += weight;
  });
  
  return totalWeight > 0 ? (totalScore / totalWeight).toFixed(1) : '0.0';
};

const calculateComplaintRate = (data) => {
  if (!data) return 0;
  
  const complaints = data.filter(d => 
    (d.question_code?.startsWith('Q7[') || d.question_code?.startsWith('Q8[')) && d.answer === 'Да'
  );
  
  let totalComplaints = 0;
  let totalRespondents = 0;
  
  complaints.forEach(complaint => {
    totalComplaints += complaint.responses_count || 0;
    totalRespondents = Math.max(totalRespondents, complaint.total_respondents || 0);
  });
  
  if (totalRespondents === 0) return 0;
  
  return Math.round((totalComplaints / totalRespondents) * 100);
};

const calculateQualityIndex = (surveyData) => {
  if (!surveyData?.children) return 0;
  
  const kidsSatisfactionData = surveyData.children.find(d => 
    d.question_code === 'Q6' && d.answer === 'да'
  );
  const satisfaction = kidsSatisfactionData ? 
    parseFloat(kidsSatisfactionData.percentage.toString().replace(',', '.')) : 0;
  
  const avgRating = parseFloat(calculateAverageRating(surveyData.children));
  const complaintRate = calculateComplaintRate(surveyData.children);
  
  const normalizedRating = Math.round((avgRating / 5) * 100);
  const satisfactionContribution = Math.round(satisfaction * 0.4);
  const ratingContribution = Math.round(normalizedRating * 0.4);
  const complaintContribution = Math.round((100 - complaintRate) * 0.2);
  
  return Math.round(satisfactionContribution + ratingContribution + complaintContribution);
};

// Функция для расчета статистики
const calculateStatistics = (surveyData) => {
  if (!surveyData || !surveyData.children || !surveyData.parents) {
    return null;
  }

  const childrenTotal = surveyData.children.find(d => d.question_code === 'Q1')?.total_respondents || 0;
  const parentsTotal = surveyData.parents.find(d => d.question_code === 'Q1')?.total_respondents || 0;
  
  const kidsSatisfactionData = surveyData.children.find(d => 
    d.question_code === 'Q6' && d.answer === 'да'
  );
  const kidsSatisfaction = kidsSatisfactionData ? 
    parseFloat(kidsSatisfactionData.percentage.toString().replace(',', '.')) : 0;
  
  const parentsSatisfactionData = surveyData.parents.find(d => 
    d.question_code === 'Q24' && d.answer === 'да, абсолютно доволен'
  );
  const parentsSatisfaction = parentsSatisfactionData ? 
    parseFloat(parentsSatisfactionData.percentage.toString().replace(',', '.')) : 0;
  
  const avgRating = calculateAverageRating(surveyData.children);
  const qualityIndex = calculateQualityIndex(surveyData);

  const satisfaction = kidsSatisfaction;
  const avgRatingNum = parseFloat(avgRating);
  const complaintRate = calculateComplaintRate(surveyData.children);
  
  const normalizedRating = Math.round((avgRatingNum / 5) * 100);
  const satisfactionContribution = Math.round(satisfaction * 0.4);
  const ratingContribution = Math.round(normalizedRating * 0.4);
  const complaintContribution = Math.round((100 - complaintRate) * 0.2);

  return {
    childrenTotal,
    parentsTotal,
    kidsSatisfaction,
    parentsSatisfaction,
    avgRating,
    qualityIndex,
    calculationDetails: {
      satisfaction,
      satisfactionContribution,
      avgRating: avgRatingNum,
      normalizedRating,
      ratingContribution,
      complaintRate,
      complaintContribution
    }
  };
};

// Функция для расчета статистики родительского контроля
const calculateParentControlStats = (surveyData) => {
  if (!surveyData?.parents) return null;

  const knowAboutControl = surveyData.parents.find(d => 
    d.question_code === 'Q30' && d.answer === 'знаю'
  );
  
  const effectiveControl = surveyData.parents.find(d => 
    d.question_code === 'Q35' && d.answer === 'да, это эффективная структура, благодаря которой питание детей улучшается'
  );

  const committeeExists = surveyData.parents.find(d => 
    d.question_code === 'Q34' && d.answer === 'да'
  );

  const willingToParticipate = surveyData.parents.find(d => 
    d.question_code === 'Q36' && (d.answer === 'да' || d.answer === 'да, при условии предоставления обучающих курсов для родителей' || d.answer === 'да, при условии конструктивного диалога с операторами питания или руководством пищеблока школы')
  );

  return {
    knowAboutControl: knowAboutControl ? Math.round(parseFloat(knowAboutControl.percentage.toString().replace(',', '.'))) : 0,
    effectiveControl: effectiveControl ? Math.round(parseFloat(effectiveControl.percentage.toString().replace(',', '.'))) : 0,
    committeeExists: committeeExists ? Math.round(parseFloat(committeeExists.percentage.toString().replace(',', '.'))) : 0,
    willingToParticipate: willingToParticipate ? Math.round(parseFloat(willingToParticipate.percentage.toString().replace(',', '.'))) : 0
  };
};

// Функция для расчета статистики обучения питанию
const calculateNutritionEducationStats = (surveyData) => {
  if (!surveyData?.children) return null;

  const schoolEducation = surveyData.children.find(d => 
    d.question_code === 'Q27' && d.answer === 'да'
  );

  const homeEducationAlways = surveyData.children.find(d => 
    d.question_code === 'Q28' && d.answer === 'да'
  );
  
  const homeEducationSometimes = surveyData.children.find(d => 
    d.question_code === 'Q28' && d.answer === 'иногда'
  );

  const parentAwareness = surveyData.parents?.find(d => 
    d.question_code === 'Q41[5]' && d.answer === 'Да'
  );

  return {
    schoolEducation: schoolEducation ? Math.round(parseFloat(schoolEducation.percentage.toString().replace(',', '.'))) : 0,
    homeEducationAlways: homeEducationAlways ? Math.round(parseFloat(homeEducationAlways.percentage.toString().replace(',', '.'))) : 0,
    homeEducationSometimes: homeEducationSometimes ? Math.round(parseFloat(homeEducationSometimes.percentage.toString().replace(',', '.'))) : 0,
    parentAwareness: parentAwareness ? Math.round(parseFloat(parentAwareness.percentage.toString().replace(',', '.'))) : 0
  };
};

// Функция для получения блюд по категориям
const getDishesByCategory = (surveyData) => {
  if (!surveyData?.children) return { popular: {}, unpopular: {} };

  const popular = {
    breakfast: surveyData.children
      .filter(d => d.question_code?.startsWith('Q12[') && d.answer === 'Да')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    soups: surveyData.children
      .filter(d => d.question_code?.startsWith('Q13[') && d.answer === 'Да')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    mainDishes: surveyData.children
      .filter(d => d.question_code?.startsWith('Q14[') && d.answer === 'Да')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    sides: surveyData.children
      .filter(d => d.question_code?.startsWith('Q15[') && d.answer === 'Да')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    fruits: surveyData.children
      .filter(d => d.question_code?.startsWith('Q16[') && d.answer === 'Да')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    bakery: surveyData.children
      .filter(d => d.question_code?.startsWith('Q17[') && d.answer === 'Да')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    dairy: surveyData.children
      .filter(d => d.question_code?.startsWith('Q18[') && d.answer === 'Да')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    bread: surveyData.children
      .filter(d => d.question_code?.startsWith('Q19[') && d.answer === 'Да')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    drinks: surveyData.children
      .filter(d => d.question_code?.startsWith('Q20[') && d.answer === 'Да')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5)
  };

  const unpopular = {
    breakfast: surveyData.children
      .filter(d => d.question_code?.startsWith('Q12[') && d.answer === 'Нет')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    soups: surveyData.children
      .filter(d => d.question_code?.startsWith('Q13[') && d.answer === 'Нет')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    mainDishes: surveyData.children
      .filter(d => d.question_code?.startsWith('Q14[') && d.answer === 'Нет')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    sides: surveyData.children
      .filter(d => d.question_code?.startsWith('Q15[') && d.answer === 'Нет')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    fruits: surveyData.children
      .filter(d => d.question_code?.startsWith('Q16[') && d.answer === 'Нет')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    bakery: surveyData.children
      .filter(d => d.question_code?.startsWith('Q17[') && d.answer === 'Нет')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    dairy: surveyData.children
      .filter(d => d.question_code?.startsWith('Q18[') && d.answer === 'Нет')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    bread: surveyData.children
      .filter(d => d.question_code?.startsWith('Q19[') && d.answer === 'Нет')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5),
    
    drinks: surveyData.children
      .filter(d => d.question_code?.startsWith('Q20[') && d.answer === 'Нет')
      .sort((a, b) => parseFloat(b.percentage.toString().replace(',', '.')) - parseFloat(a.percentage.toString().replace(',', '.')))
      .slice(0, 5)
  };

  return { popular, unpopular };
};

// Функция для генерации рекомендаций
const generateRecommendations = (statistics, surveyData, parentControlStats, dishesByCategory) => {
  const recommendations = [];

  if (statistics.kidsSatisfaction < 60) {
    recommendations.push('Низкий уровень удовлетворенности детей. Рекомендуется провести детальный анализ причин недовольства.');
  }

  if (statistics.parentsSatisfaction < 50) {
    recommendations.push('Родители выражают значительное недовольство. Необходимо усилить коммуникацию с родительским сообществом.');
  }

  const avgRatingNum = parseFloat(statistics.avgRating);
  if (avgRatingNum < 3.5) {
    recommendations.push('Низкие оценки питания. Требуется пересмотр меню и качества приготовления блюд.');
  }

  const unpopularDishesCount = Object.values(dishesByCategory.unpopular)
    .reduce((count, dishes) => count + (dishes ? dishes.length : 0), 0);
  
  if (unpopularDishesCount > 10) {
    recommendations.push('В случае использования непопулярных блюд в меню, следует пересмотреть их наличие');
  }

  const buffetBuyers = surveyData.children.find(d => 
    d.question_code === 'Q25' && d.answer === 'да'
  );
  const buyersPercent = buffetBuyers ? Math.round(parseFloat(buffetBuyers.percentage.toString().replace(',', '.'))) : 0;
  
  if (buyersPercent < 20) {
    recommendations.push('Низкая активность покупок в буфете. Следует разнообразить ассортимент и рассмотреть ценообразование.');
  }

  if (parentControlStats && parentControlStats.knowAboutControl < 30) {
    recommendations.push('Низкая осведомленность родителей о возможности контроля. Необходимо усилить информирование.');
  }

  if (statistics.qualityIndex >= 80) {
    recommendations.push('Высокие показатели качества. Рекомендуется поддерживать текущий уровень и делиться лучшими практиками.');
  } else if (statistics.qualityIndex >= 60) {
    recommendations.push('Стабильные показатели. Возможны точечные улучшения в проблемных зонах.');
  } else {
    recommendations.push('Требуется комплексный подход к улучшению качества питания: пересмотр меню, улучшение качества приготовления, усиление коммуникации.');
  }

  return recommendations;
};

// Основная функция генерации PDF отчета
export const generatePdfReport = async (surveyData, entityName, level) => {
  return new Promise((resolve, reject) => {
    try {
      // Рассчитываем все необходимые данные
      const statistics = calculateStatistics(surveyData);
      const parentControlStats = calculateParentControlStats(surveyData);
      const nutritionEducationStats = calculateNutritionEducationStats(surveyData);
      const dishesByCategory = getDishesByCategory(surveyData);
      const recommendations = generateRecommendations(statistics, surveyData, parentControlStats, dishesByCategory);

      // Создаем структуру документа
      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [20, 60, 20, 40],
        header: function(currentPage, pageCount) {
          // На титульной странице не показываем номер страницы
          if (currentPage === 1) {
            return [];
          }
          // Корректируем нумерацию - не считаем титульную страницу
          const displayPage = currentPage - 1;
          const displayPageCount = pageCount - 1;
          
          return {
            margin: [20, 15, 20, 0],
            columns: [
              {
                text: `Отчет по опросу питания: ${entityName}`,
                fontSize: 11,
                color: '#666666',
                alignment: 'left'
              },
              {
                text: `Страница ${displayPage} из ${displayPageCount}`,
                fontSize: 11,
                color: '#666666',
                alignment: 'right'
              }
            ]
          };
        },
        footer: function(currentPage, pageCount) {
          return {
            margin: [20, 10, 20, 15],
            columns: [
              {
                text: `Сгенерировано: ${new Date().toLocaleDateString('ru-RU')}`,
                fontSize: 9,
                color: '#999999',
                alignment: 'left'
              },
              {
                text: 'Система мониторинга школьного питания https://pitanie.spb.ru',
                fontSize: 9,
                color: '#999999',
                alignment: 'right'
              }
            ]
          };
        },
        background: function(currentPage) {
          if (currentPage === 1) {
            return [
              {
                canvas: [
                  {
                    type: 'rect',
                    x: 0, y: 0,
                    w: 595, h: 80,
                    color: '#1b567b'
                  }
                ]
              },
              {
                text: 'Аналитический отчет',
                absolutePosition: { x: 20, y: 25 },
                fontSize: 22,
                bold: true,
                color: '#ffffff'
              },
              {
                text: 'по результатам опроса удовлетворенности питанием',
                absolutePosition: { x: 20, y: 50 },
                fontSize: 14,
                color: '#ffffff',
                opacity: 0.9
              }
            ];
          }
          return null;
        },
        content: [],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 8],
            color: '#1b567b'
          },
          subheader: {
            fontSize: 14,
            bold: true,
            margin: [0, 12, 0, 6],
            color: '#2c3e50'
          },
          sectionHeader: {
            fontSize: 13,
            bold: true,
            margin: [0, 15, 0, 8],
            color: '#1b567b',
            background: '#f8f9fa',
            border: [1, 1, 1, 1],
            borderColor: '#e9ecef',
            borderRadius: 4,
            padding: [8, 6]
          },
          normal: {
            fontSize: 12,
            margin: [0, 2, 0, 2],
            lineHeight: 1.3
          },
          bold: {
            fontSize: 11,
            bold: true,
            margin: [0, 2, 0, 2],
            lineHeight: 1.3
          },
          small: {
            fontSize: 10,
            margin: [0, 1, 0, 1],
            lineHeight: 1.2
          },
          qualityExcellent: {
            fontSize: 12,
            bold: true,
            color: '#2a9d8f',
            margin: [0, 6, 0, 4],
            background: '#f1faee',
            border: [1, 1, 1, 1],
            borderColor: '#2a9d8f',
            borderRadius: 4,
            padding: [6, 4]
          },
          qualityGood: {
            fontSize: 12,
            bold: true,
            color: '#e9c46a',
            margin: [0, 6, 0, 4],
            background: '#fff9e6',
            border: [1, 1, 1, 1],
            borderColor: '#e9c46a',
            borderRadius: 4,
            padding: [6, 4]
          },
          qualityPoor: {
            fontSize: 12,
            bold: true,
            color: '#e76f51',
            margin: [0, 6, 0, 4],
            background: '#fdf2f0',
            border: [1, 1, 1, 1],
            borderColor: '#e76f51',
            borderRadius: 4,
            padding: [6, 4]
          }
        },
        defaultStyle: {
          font: 'Roboto',
          fontSize: 12,
          lineHeight: 1.3
        }
      };

      // ТИТУЛЬНАЯ СТРАНИЦА (отдельно)
      docDefinition.content.push(
        {
          stack: [
            {
              text: 'Аналитический отчет',
              fontSize: 24,
              bold: true,
              color: '#1b567b',
              margin: [0, 120, 0, 20],
              alignment: 'center'
            },
            {
              text: 'по результатам опроса удовлетворенности питанием',
              fontSize: 16,
              color: '#2c3e50',
              margin: [0, 0, 0, 60],
              alignment: 'center'
            },
            {
              text: 'Информация об организации',
              style: 'sectionHeader',
              margin: [0, 0, 0, 20]
            },
            {
              columns: [
                {
                  width: '50%',
                  stack: [
                    {
                      text: 'Образовательная организация:',
                      fontSize: 12,
                      bold: true,
                      margin: [0, 0, 0, 4]
                    },
                    {
                      text: entityName,
                      fontSize: 14,
                      color: '#2c3e50',
                      margin: [0, 0, 0, 20]
                    }
                  ]
                },
                {
                  width: '50%',
                  stack: [
                    {
                      text: 'Уровень:',
                      fontSize: 12,
                      bold: true,
                      margin: [0, 0, 0, 4]
                    },
                    {
                      text: getLevelLabel(level),
                      fontSize: 12,
                      color: '#7f8c8d',
                      margin: [0, 0, 0, 20]
                    }
                  ]
                }
              ]
            },
            {
              columns: [
                {
                  width: '50%',
                  stack: [
                    {
                      text: 'Дата генерации отчета:',
                      fontSize: 12,
                      bold: true,
                      margin: [0, 0, 0, 4]
                    },
                    {
                      text: new Date().toLocaleDateString('ru-RU'),
                      fontSize: 12,
                      color: '#7f8c8d',
                      margin: [0, 0, 0, 20]
                    }
                  ]
                },
                {
                  width: '50%',
                  stack: [
                    {
                      text: 'Количество респондентов:',
                      fontSize: 12,
                      bold: true,
                      margin: [0, 0, 0, 4]
                    },
                    {
                      text: `${statistics.childrenTotal} детей, ${statistics.parentsTotal} родителей`,
                      fontSize: 12,
                      color: '#7f8c8d',
                      margin: [0, 0, 0, 20]
                    }
                  ]
                }
              ]
            },
            {
              text: '',
              margin: [0, 80, 0, 0]
            },
            {
              text: `Сгенерировано: ${new Date().toLocaleDateString('ru-RU')}`,
              fontSize: 10,
              color: '#999999',
              alignment: 'center',
              margin: [0, 20, 0, 0]
            }
          ],
          pageBreak: 'after'
        }
      );

      // СТРАНИЦА 2: КЛЮЧЕВЫЕ ПОКАЗАТЕЛИ
      docDefinition.content.push(
        { text: 'Ключевые показатели', style: 'header' },
        
        // Основные метрики
        {
          columns: [
            {
              width: '33%',
              ...createMetricCard(
                'Удовлетворенность детей', 
                Math.round(statistics.kidsSatisfaction), 
                '%',
                'Довольны питанием'
              )
            },
            {
              width: '33%',
              ...createMetricCard(
                'Удовлетворенность родителей', 
                Math.round(statistics.parentsSatisfaction), 
                '%',
                'Абсолютно довольны'
              )
            },
            {
              width: '33%',
              ...createMetricCard(
                'Средняя оценка', 
                statistics.avgRating, 
                '/5',
                'Оценка качества питания'
              )
            }
          ],
          margin: [0, 0, 0, 20]
        },
        {
          columns: [
            {
              width: '50%',
              ...createMetricCard(
                'Индекс качества', 
                Math.round(statistics.qualityIndex), 
                ' баллов',
                getQualityText(statistics.qualityIndex)
              )
            },
            {
              width: '50%',
              ...createMetricCard(
                'Охват опросом', 
                statistics.childrenTotal + statistics.parentsTotal, 
                ' респондентов',
                `${statistics.childrenTotal} детей + ${statistics.parentsTotal} родителей`
              )
            }
          ],
          margin: [0, 0, 0, 30]
        },

        // Визуализации
        {
          columns: [
            {
              width: '50%',
              stack: [
                createSatisfactionComparison(statistics.kidsSatisfaction, statistics.parentsSatisfaction),
                { text: '', margin: [0, 15, 0, 0] },
                createRatingDistribution(surveyData)
              ]
            },
            {
              width: '50%',
              stack: [
                createQualityIndicator(statistics.qualityIndex),
                { text: '', margin: [0, 15, 0, 0] },
                createPopularDishesVisualization(dishesByCategory)
              ]
            }
          ],
          margin: [0, 0, 0, 20]
        },

        // Интерпретация индекса качества
        {
          stack: [
            {
              text: 'Интерпретация индекса качества',
              style: 'sectionHeader',
              margin: [0, 0, 0, 8]
            },
            {
              text: getQualityInterpretation(statistics.qualityIndex),
              fontSize: 11,
              lineHeight: 1.4,
              margin: [0, 0, 0, 6]
            }
          ],
          margin: [0, 0, 0, 20]
        }
      );

      // СТРАНИЦА 3: Детальный анализ удовлетворенности
      docDefinition.content.push(
        { text: 'Детальный анализ удовлетворенности', style: 'header', pageBreak: 'before' },
        
        // Детская удовлетворенность
        {
          text: 'Удовлетворенность детей питанием',
          style: 'sectionHeader'
        },
        {
          text: `Общий уровень удовлетворенности: ${Math.round(statistics.kidsSatisfaction)}%`,
          style: 'bold'
        },
        {
          text: `Средняя оценка питания: ${statistics.avgRating} из 5`,
          style: 'bold',
          margin: [0, 0, 0, 8]
        },
        {
          canvas: [
            {
              type: 'rect',
              x: 0, y: 0,
              w: Math.round((statistics.kidsSatisfaction / 100) * 400), h: 15,
              color: '#3498db',
              fillOpacity: 0.8
            }
          ],
          margin: [0, 0, 0, 12]
        },

        // Родительская удовлетворенность
        {
          text: 'Удовлетворенность родителей питанием',
          style: 'sectionHeader',
          margin: [0, 15, 0, 0]
        },
        {
          text: `Абсолютно довольны: ${Math.round(statistics.parentsSatisfaction)}%`,
          style: 'bold'
        },
        {
          canvas: [
            {
              type: 'rect',
              x: 0, y: 0,
              w: Math.round((statistics.parentsSatisfaction / 100) * 400), h: 15,
              color: '#9b59b6',
              fillOpacity: 0.8
            }
          ],
          margin: [0, 0, 0, 12]
        }
      );

      // Статистика родительского контроля
      if (parentControlStats) {
        docDefinition.content.push(
          {
            text: 'Родительский контроль питания',
            style: 'sectionHeader',
            margin: [0, 15, 0, 0]
          },
          {
            columns: [
              {
                width: '50%',
                stack: [
                  { text: 'Знают о возможности контроля', style: 'bold' },
                  { text: `${parentControlStats.knowAboutControl}%`, fontSize: 16, bold: true, color: '#27ae60' },
                  {
                    canvas: [
                      {
                        type: 'rect',
                        x: 0, y: 0,
                        w: Math.round((parentControlStats.knowAboutControl / 100) * 150), h: 8,
                        color: '#27ae60',
                        fillOpacity: 0.8
                      }
                    ],
                    margin: [0, 4, 0, 0]
                  }
                ]
              },
              {
                width: '50%',
                stack: [
                  { text: 'Считают контроль эффективным', style: 'bold' },
                  { text: `${parentControlStats.effectiveControl}%`, fontSize: 16, bold: true, color: '#f39c12' },
                  {
                    canvas: [
                      {
                        type: 'rect',
                        x: 0, y: 0,
                        w: Math.round((parentControlStats.effectiveControl / 100) * 150), h: 8,
                        color: '#f39c12',
                        fillOpacity: 0.8
                      }
                    ],
                    margin: [0, 4, 0, 0]
                  }
                ]
              }
            ],
            margin: [0, 0, 0, 8]
          },
          {
            columns: [
              {
                width: '50%',
                stack: [
                  { text: 'Готовы участвовать', style: 'bold' },
                  { text: `${parentControlStats.willingToParticipate}%`, fontSize: 16, bold: true, color: '#3498db' },
                  {
                    canvas: [
                      {
                        type: 'rect',
                        x: 0, y: 0,
                        w: Math.round((parentControlStats.willingToParticipate / 100) * 150), h: 8,
                        color: '#3498db',
                        fillOpacity: 0.8
                      }
                    ],
                    margin: [0, 4, 0, 0]
                  }
                ]
              },
              {
                width: '50%',
                stack: [
                  { text: 'Комиссия существует', style: 'bold' },
                  { text: `${parentControlStats.committeeExists}%`, fontSize: 16, bold: true, color: '#e74c3c' },
                  {
                    canvas: [
                      {
                        type: 'rect',
                        x: 0, y: 0,
                        w: Math.round((parentControlStats.committeeExists / 100) * 150), h: 8,
                        color: '#e74c3c',
                        fillOpacity: 0.8
                      }
                    ],
                    margin: [0, 4, 0, 0]
                  }
                ]
              }
            ],
            margin: [0, 0, 0, 12]
          }
        );
      }

      // Статистика обучения питанию
      if (nutritionEducationStats) {
        docDefinition.content.push(
          {
            text: 'Обучение правильному питанию',
            style: 'sectionHeader',
            margin: [0, 15, 0, 0]
          },
          {
            columns: [
              {
                width: '50%',
                stack: [
                  { text: 'Обучение в школе', style: 'bold' },
                  { text: `${nutritionEducationStats.schoolEducation}%`, fontSize: 16, bold: true, color: '#27ae60' },
                  {
                    canvas: [
                      {
                        type: 'rect',
                        x: 0, y: 0,
                        w: Math.round((nutritionEducationStats.schoolEducation / 100) * 150), h: 8,
                        color: '#27ae60',
                        fillOpacity: 0.8
                      }
                    ],
                    margin: [0, 4, 0, 0]
                  }
                ]
              },
              {
                width: '50%',
                stack: [
                  { text: 'Обучение дома (всегда)', style: 'bold' },
                  { text: `${nutritionEducationStats.homeEducationAlways}%`, fontSize: 16, bold: true, color: '#f39c12' },
                  {
                    canvas: [
                      {
                        type: 'rect',
                        x: 0, y: 0,
                        w: Math.round((nutritionEducationStats.homeEducationAlways / 100) * 150), h: 8,
                        color: '#f39c12',
                        fillOpacity: 0.8
                      }
                    ],
                    margin: [0, 4, 0, 0]
                  }
                ]
              }
            ],
            margin: [0, 0, 0, 12]
          }
        );
      }

      // СТРАНИЦА 4: Анализ популярных и непопулярных блюд
      docDefinition.content.push(
        { text: 'Анализ блюд', style: 'header', pageBreak: 'before' },
        {
          text: 'Популярные блюда по категориям',
          style: 'sectionHeader'
        }
      );

      // Добавляем популярные блюда по категориям
      Object.entries(dishesByCategory.popular).forEach(([category, dishes]) => {
        if (dishes && dishes.length > 0) {
          const categoryContent = [];
          
          categoryContent.push({
            text: getCategoryLabel(category),
            fontSize: 12,
            bold: true,
            background: '#e8f4fd',
            border: [1, 1, 1, 1],
            borderColor: '#3498db',
            borderRadius: 4,
            padding: [6, 4],
            margin: [0, 8, 0, 6]
          });

          dishes.slice(0, 3).forEach((dish, index) => {
            const percentage = Math.round(parseFloat(dish.percentage.toString().replace(',', '.')));
            const dishName = getShortLabel(dish.question_text, 35);
            
            categoryContent.push({
              columns: [
                {
                  width: '10%',
                  text: `${index + 1}.`,
                  fontSize: 11,
                  bold: true,
                  color: '#2c3e50'
                },
                {
                  width: '60%',
                  text: dishName,
                  fontSize: 11
                },
                {
                  width: '20%',
                  canvas: [
                    {
                      type: 'rect',
                      x: 0, y: 0,
                      w: Math.round((percentage / 100) * 50), h: 8,
                      color: '#27ae60',
                      fillOpacity: 0.8
                    }
                  ]
                },
                {
                  width: '10%',
                  text: `${percentage}%`,
                  fontSize: 11,
                  bold: true,
                  color: '#27ae60',
                  alignment: 'right'
                }
              ],
              margin: [0, 0, 0, 4]
            });
          });

          docDefinition.content.push(...categoryContent);
        }
      });

      // Рекомендации (БЕЗ разрыва страницы)
      docDefinition.content.push(
        { text: 'Рекомендации по улучшению', style: 'header' },
        {
          text: 'Основные рекомендации',
          style: 'sectionHeader'
        }
      );

      // Добавляем рекомендации
      recommendations.forEach((recommendation, index) => {
        docDefinition.content.push({
          columns: [
            {
              width: '10%',
              text: `${index + 1}.`,
              fontSize: 12,
              bold: true,
              color: '#1b567b'
            },
            {
              width: '90%',
              text: recommendation,
              fontSize: 12,
              lineHeight: 1.4,
              margin: [0, 0, 0, 6]
            }
          ],
          margin: [0, 0, 0, 8]
        });
      });

      // Приложение: Методология расчета
      docDefinition.content.push(
        { text: 'Приложение', style: 'header', pageBreak: 'before' },
        {
          text: 'Методология расчета индекса качества питания',
          style: 'sectionHeader'
        },
        {
          text: 'Индекс качества питания рассчитывается на основе трех ключевых показателей:',
          fontSize: 11,
          margin: [0, 0, 0, 8]
        },
        {
          ul: [
            'Удовлетворенность питанием (40% веса)',
            'Средняя оценка качества (40% веса)', 
            'Отсутствие жалоб (20% веса)'
          ],
          fontSize: 11,
          margin: [0, 0, 0, 8]
        },
        {
          text: 'Формула расчета:',
          fontSize: 11,
          bold: true,
          margin: [0, 8, 0, 4]
        },
        {
          text: 'Индекс = (Удовлетворенность × 0.4) + (Нормализованная_оценка × 0.4) + ((100 - Жалобы) × 0.2)',
          fontSize: 10,
          background: '#f8f9fa',
          border: [1, 1, 1, 1],
          borderColor: '#e9ecef',
          padding: [8, 6],
          margin: [0, 0, 0, 8]
        },
        {
          text: 'Где:',
          fontSize: 11,
          margin: [0, 8, 0, 4]
        },
        {
          ul: [
            'Удовлетворенность - процент довольных питанием',
            'Нормализованная_оценка - средняя оценка (из 5), приведенная к 100-балльной шкале',
            'Жалобы - процент респондентов, сообщивших о проблемах'
          ],
          fontSize: 10,
          margin: [0, 0, 0, 12]
        }
      );

      // Генерируем PDF
      const pdfDocGenerator = pdfMake.createPdf(docDefinition);
      
      pdfDocGenerator.getBlob((blob) => {
        resolve(blob);
      });

    } catch (error) {
      console.error('Error generating PDF:', error);
      reject(error);
    }
  });
};

// Функция для скачивания PDF
export const downloadPdfReport = async (surveyData, entityName, level) => {
  try {
    const pdfBlob = await generatePdfReport(surveyData, entityName, level);
    const url = URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `отчет_питание_${entityName}_${new Date().toISOString().split('T')[0]}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('Ошибка при скачивании PDF:', error);
    throw error;
  }
};

// Экспорт всех функций
export default {
  generatePdfReport,
  downloadPdfReport,
  calculateStatistics,
  calculateParentControlStats,
  calculateNutritionEducationStats,
  getDishesByCategory,
  generateRecommendations
};